export const stringToNumber = (str: string | number) => {
  try {
    return parseInt(str.toString());
  } catch (error) {
    return 0;
  }
};
